import axios from "axios";

export default axios.create({
    baseURL: 'https://www.googleapis.com/youtube/v3',
    // params: {
    //     part: 'snippet',
    //     maxResults: 5,
    //     key: 'AIzaSyBJKduVHp_AZ-wY1krIkkhJ-R0g4MD7QhA'
    // }
});